import { useTranslation } from 'react-i18next'
import { Item, ItemLabel, ItemValue } from '../_styles'
import { useProduct } from '../../../_methods'
import { getWineRegionGI } from 'utils/wine'

const Country = () => {
  const { t } = useTranslation()

  const product = useProduct()

  const wine = product?.wine
  const country = wine?.country?.localizedName
  const region = getWineRegionGI(wine)
  const value = [country, region].filter(Boolean).join(', ')

  if (!value) return null

  return (
    <Item>
      <ItemLabel>{t('wine.view.country')}</ItemLabel>
      <ItemValue>{value}</ItemValue>
    </Item>
  )
}

export default Country
